import * as client from '../../services/client';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import './ServiceRequest.scss';
import './ServiceRequestDetails.scss';
import ServiceRequestDetails from './ServiceRequestDetails';
import ServiceRequestDocuments from './ServiceRequestDocuments.jsx';
import ServiceRequestNotes from './ServiceRequestNotes';
import ServiceRequestMessages from './ServiceRequestMessages';
import { PATHS } from '../../common/constants';
import Tabs from '../../components/Tabs';
import Timeline from '../../components/Timeline/Timeline';
import WithNavigation from '../../layouts/WithNavigation';
import Loader from '../../components/Loader';
import Overlay from '../../components/Overlay';
import ServiceRequestEditForm from '../../components/ServiceRequestForm/ServiceRequestEditForm';
import {
  deleteServiceRequest,
  updateBulkStatus,
} from '../../store/actions/serviceRequests';
import { fetchAllTicketStatus } from '../../store/actions/formOptions';
import {
  fetchServiceRequestById,
  fetchServiceRequestActivityById,
  saveScheduledAppointment,
  saveStatus,
  clearServiceRequestDone,
  updateServiceRequest,
  updateServiceRequestOneYearWarrantyIssueStatus,
  fetchServiceRequestByIdDone,
  updateWarrantyIssueStatusAndLoading,
} from '../../store/actions/serviceRequest';
import {
  fetchServiceRequestFaqsNotesDocuments,
  clearNotes,
} from '../../store/actions/faqsNotesDocuments';
import { fetchMessages, clearMessages } from '../../store/actions/Messages';
import {
  selectNotes,
  selectDocuments,
} from '../../store/selectors/faqsNotesDocuments';
import { selectMessages } from '../../store/selectors/Messages';
import { selectAuthenticatedUser } from '../../store/selectors/auth';
import 'react-image-lightbox/style.css';
import { selectFormLoader } from '../../store/selectors/FormLoader';
import Popup from './Popup';
import ServiceRequestAssignForm from './ServiceRequestAssignForm';
import ServiceRequestScheduling from './ServiceRequestScheduling';
import { fetchtAllowedTabList } from '../../store/actions/tabSelections';
import ServiceLog from './ServiceLog';
import { selectServiceRequests } from '../../store/selectors/serviceRequests';
import { BrandingContext } from '../../branding/BrandingContextProvider';
import { ServiceRequestDetailHeader } from './components/ServiceRequestDetailHeader.jsx';

import download from 'downloadjs';

class ServiceRequest extends Component {
  state = {
    showOverlay: false,
    isOpen: false,
    Open: false,
    showPopup: false,
    serviceRequestId: '',
    statusOverlay: false,
    statusScheduleOverlay: false,
    serviceRequestActualTime: '',
    serviceRequestEstimatedTime: '',
  };

  componentWillMount() {
    this.refreshData();
  }

  refreshData() {
    const {
      match,
      onFetchNotesAndDocuments,
      onFetchServiceRequestById,
      onFetchMessages,
      clearMessages,
      onClearServiceRequestDone,
      onFetchServiceRequestActivityById,
      onfetchAllTicketStatus,
      clearNotes,
    } = this.props;
    onClearServiceRequestDone();
    clearNotes();
    clearMessages();
    var serviceRequestId = match.params.id;
    onFetchServiceRequestById(serviceRequestId);
    onFetchServiceRequestActivityById(serviceRequestId);
    onFetchNotesAndDocuments(serviceRequestId);
    onfetchAllTicketStatus();

    let data = {
      ReferenceId: serviceRequestId,
      ReferenceType: 'Ticket',
    };
    onFetchMessages(data);
  }

  componentDidMount() {
    const { fetchtAllowedTabList, serviceRequest } = this.props;
    fetchtAllowedTabList(serviceRequest.propertyId);

    setTimeout(() => {
      this.props.onFetchServiceRequestById(this.props.serviceRequest.id);
    }, 3000);
  }
  downloadPdf(id) {
    client.getServiceRequestPdfById(id).then((response) => {
      if (response.ok || response.status === 200) {
        response.text().then((text) => {
          download(text.substring(1, text.length - 1));
        });
      }
    });
  }
  deleteServiceRequest(data, history) {
    this.props.onDeleteServiceRequest(data.id, history);
    this.setState({ state: this.state });
  }

  async handleSaveScheduledAppointment(formData, serviceRequestId) {
    const {
      onSaveScheduledAppointment,
      onFetchServiceRequestActivityById,
      user,
      serviceRequest,
      ticketStatus,
    } = this.props;
    let status = ticketStatus.filter((u) => u.name === formData.name);
    await onSaveScheduledAppointment(
      {
        ...formData,
        LoginUserId: user.id,
        ticketId: serviceRequest.ticketId,
        userId: serviceRequest.serviceProvider.id,
        TicketStatusId: status[0].id,
      },
      serviceRequestId
    );
    onFetchServiceRequestActivityById(serviceRequestId);
  }

  async handleStatusChange(statusFormData, serviceRequestId) {
    const {
      onSaveStatus,
      user,
      onFetchServiceRequestActivityById,
      ticketStatus,
      updateBulkStatus,
    } = this.props;
    if (statusFormData.name === 'Assigned') {
      this.setState({ statusOverlay: true });
    } else if (statusFormData.name === 'Scheduled') {
      this.setState({ statusScheduleOverlay: true });
    } else if (statusFormData.name === 'Declined') {
      this.setState({ showPopup: true, serviceRequestId: serviceRequestId });
    } else if (statusFormData.name === 'Archive') {
      const role = user.roles[0].role.name;
      const archiveParams = {
        serviceRequest: [{ id: serviceRequestId }],
        name: statusFormData.name,
        userId: user.id,
      };
      const from = 'serviceRequest';
      updateBulkStatus(archiveParams, role, 'params1', from);
    } else {
      let status = ticketStatus.filter((u) => u.name === statusFormData.name);
      await onSaveStatus(
        {
          ...statusFormData,
          LoginUserId: user.id,
          TicketStatusId: status[0].id,
        },
        serviceRequestId
      );
      onFetchServiceRequestActivityById(serviceRequestId);
    }
  }

  handleStatusAssign = async (statusFormData, serviceRequestId) => {
    const {
      onSaveStatus,
      onFetchServiceRequestActivityById,
      user,
      ticketStatus,
    } = this.props;
    let status = ticketStatus.filter((u) => u.name === 'Assigned');
    let params = {
      LoginUserId: user.id,
      name: 'Assigned',
      ServiceProviderId: statusFormData.userId,
      TicketStatusId: status[0].id,
    };
    await onSaveStatus(params, serviceRequestId);
    this.setState({ statusOverlay: false });
    onFetchServiceRequestActivityById(serviceRequestId);
  };

  onSubmitPopup = async (type, data) => {
    const {
      onSaveStatus,
      user,
      onFetchServiceRequestActivityById,
      ticketStatus,
    } = this.props;
    if (type === 'cancel') {
      this.setState({ showPopup: false, serviceRequestId: '' });
    } else {
      let status = ticketStatus.filter((u) => u.name === 'Declined');
      let params = {
        name: 'Declined',
        Reason: data.description,
        ReasonType: data.reason,
        LoginUserId: user.id,
        TicketStatusId: status[0].id,
      };
      this.setState({ showPopup: false });
      await onSaveStatus(params, this.state.serviceRequestId);
      onFetchServiceRequestActivityById(this.state.serviceRequestId);
      this.setState({ serviceRequestId: '' });
    }
  };

  updateOneYearWarrantyStatus = () => {
    const oneYearWarrantyIssueParams = {
      id: this.props.serviceRequest.id,
      IsOneYearWarrantyIssue: this.props.serviceRequest.oneYearWarrantyIssues,
    };
    this.props.updateServiceRequestOneYearWarrantyIssueStatus(
      oneYearWarrantyIssueParams
    );
  };

  static contextType = BrandingContext;
  render() {
    const {
      serviceRequest,
      history,
      notes,
      documents,
      match,
      messages,
      user,
      loader,
      notesList,
    } = this.props;

    const HmeOwnrOcpntRltrNotes = [];
    let noteVisibleToHomeownerOccupantRealtor = false;

    if (
      notesList !== undefined &&
      notesList !== null &&
      notesList !== '' &&
      notesList.length > 0
    ) {
      let notes = notesList.filter((x) => x.type === 'NOTES');

      if (notes.length > 0) {
        notes.forEach((object) => {
          HmeOwnrOcpntRltrNotes.push(
            JSON.parse(JSON.parse(JSON.stringify(object.data)))
          );
        });
      }

      if (HmeOwnrOcpntRltrNotes.length > 0) {
        let filterNotes = HmeOwnrOcpntRltrNotes.filter(
          (x) => x.noteVisibleToHomeownerOccupantRealtor === true
        );

        if (filterNotes.length > 0) {
          noteVisibleToHomeownerOccupantRealtor = true;
        }
      }
    }
    const { showOverlay, statusOverlay, statusScheduleOverlay } = this.state;
    const serviceRequestId = match.params.id;
    let activeTab = 0;
    let location = this.props.location;

    if (location && location.state && location.state.activeTab) {
      activeTab = location.state.activeTab;
    } else {
      let string = window.location.href;
      let splitValue = string.split('activeTab=')[1];
      if (splitValue !== undefined) {
        activeTab = Number(splitValue);
      }
    }

    if (serviceRequest.id) {
      return (
        <>
          {serviceRequest.loading ? <Loader center={true} /> : null}
          <WithNavigation
            title={
              serviceRequest.ticketNumber
                ? serviceRequest.ticketNumber
                : serviceRequest.ticketId
            }
            top={
              <ServiceRequestDetailHeader
                serviceRequest={serviceRequest}
                user={user}
                location={location}
                onEditServiceRequest={() =>
                  this.setState({ showOverlay: true })
                }
                onDeleteServiceRequest={() =>
                  this.deleteServiceRequest(serviceRequest, history)
                }
                onDownloadPdf={() => this.downloadPdf(serviceRequest.id)}
                navigateTo={this.props.navigateTo}
                handleStatusChange={(statusFormData, serviceRequestId) =>
                  this.handleStatusChange(statusFormData, serviceRequestId)
                }
              />
            }
            bottom={
              <div className="serviceRequest">
                {loader ? <Loader center={true} /> : null}
                {
                  <div className="serviceRequest__timeline">
                    {
                      <Timeline
                        activity={serviceRequest.activity}
                        loading={
                          serviceRequest.activity &&
                          serviceRequest.activity.length > 0
                            ? false
                            : true
                        }
                      />
                    }
                  </div>
                }
                <div className="serviceRequest__tabs">
                  <Tabs
                    activeTab={activeTab}
                    items={[
                      {
                        label: 'Details',
                        content: (
                          <ServiceRequestDetails
                            serviceRequest={serviceRequest}
                            user={user}
                          />
                        ),
                      },
                      {
                        label: 'Messages',
                        count: messages.length.toString(),
                        content: (
                          <ServiceRequestMessages
                            serviceRequest={serviceRequest}
                            serviceRequestId={serviceRequestId}
                            history={history}
                            url={PATHS.SERVICE_REQUESTS_VIEW.replace(
                              ':id',
                              match.params.id
                            )}
                            ticketId={serviceRequest.ticketId}
                          />
                        ),
                      },
                      {
                        label: 'Photos & Documents',
                        count: documents.length.toString(),
                        content: (
                          <ServiceRequestDocuments
                            serviceRequest={serviceRequest}
                          />
                        ),
                      },
                      (user.roles[0].role.name === 'Home Owner' ||
                        user.roles[0].role.name === 'Realtor' ||
                        user.roles[0].role.name === 'Occupant') &&
                      noteVisibleToHomeownerOccupantRealtor === false
                        ? {}
                        : {
                            label: 'Notes',
                            count: notes.length.toString(),
                            content: (
                              <ServiceRequestNotes
                                serviceRequest={serviceRequest}
                              />
                            ),
                          },
                      user.roles[0].role.name === 'Property Developer' ||
                      user.roles[0].role.name === 'Strata Manager' ||
                      user.roles[0].role.name === 'Service Manager' ||
                      user.roles[0].role.name === 'Service Provider'
                        ? {
                            label: 'Service Log',
                            content: (
                              <ServiceLog
                                serviceRequestId={serviceRequestId}
                                actualTime={serviceRequest.actualTime}
                                estimatedTime={serviceRequest.estimatedTime}
                              />
                            ),
                          }
                        : {},
                    ]}
                  />
                </div>
                <Overlay
                  showOverlay={showOverlay}
                  content={
                    <ServiceRequestEditForm
                      serviceRequest={serviceRequest}
                      onClose={() => {
                        this.setState({ showOverlay: false });
                        setTimeout(() => {
                          this.refreshData();
                        }, 300);
                      }}
                      handleSaveScheduledAppointment={(
                        formData,
                        serviceRequestId
                      ) =>
                        this.handleSaveScheduledAppointment(
                          formData,
                          serviceRequestId
                        )
                      }
                      handleStatusChange={this.handleStatusAssign.bind(this)}
                    />
                  }
                />
                <Overlay
                  showOverlay={statusOverlay}
                  content={
                    <ServiceRequestAssignForm
                      serviceRequest={serviceRequest}
                      onClose={() => this.setState({ statusOverlay: false })}
                      handleStatusChange={this.handleStatusAssign}
                      isLegacyTable={false}
                    />
                  }
                />
                <Overlay
                  showOverlay={statusScheduleOverlay}
                  content={
                    <ServiceRequestScheduling
                      serviceRequest={serviceRequest}
                      onClose={() =>
                        this.setState({ statusScheduleOverlay: false })
                      }
                      onEventScheduled={(data) =>
                        this.handleSaveScheduledAppointment(
                          data,
                          serviceRequest.id
                        )
                      }
                    />
                  }
                />
                {this.state.showPopup ? (
                  <Popup onSubmitPopup={this.onSubmitPopup} />
                ) : null}
              </div>
            }
          />
        </>
      );
    }

    return <Loader center={true} />;
  }
}

const mapStateToProps = (state, ownProps) => ({
  serviceRequest: state.serviceRequest,
  notes: selectNotes(state),
  documents: selectDocuments(state),
  messages: selectMessages(state),
  user: selectAuthenticatedUser(state),
  loader: selectFormLoader(state),
  ticketStatus: state.formOptions.ticketStatus,
  serviceRequests: selectServiceRequests(state),
  notesList: state.notes,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      onClearServiceRequestDone: clearServiceRequestDone,
      clearMessages: clearMessages,
      onDeleteServiceRequest: deleteServiceRequest,
      onFetchNotesAndDocuments: fetchServiceRequestFaqsNotesDocuments,
      onSaveScheduledAppointment: saveScheduledAppointment,
      onSaveStatus: saveStatus,
      onFetchServiceRequestById: fetchServiceRequestById,
      updateWarrantyIssueStatusAndLoading: updateWarrantyIssueStatusAndLoading,
      updateServiceRequestOneYearWarrantyIssueStatus:
        updateServiceRequestOneYearWarrantyIssueStatus,
      fetchServiceRequestByIdDone: fetchServiceRequestByIdDone,
      onFetchMessages: fetchMessages,
      onUpdateServiceRequest: updateServiceRequest,
      onFetchServiceRequestActivityById: fetchServiceRequestActivityById,
      onfetchAllTicketStatus: fetchAllTicketStatus,
      fetchtAllowedTabList: fetchtAllowedTabList,
      updateBulkStatus: updateBulkStatus,
      clearNotes,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ServiceRequest);
